(function($) {

    if ($('#smx-add-to-cart').length) {

        $(window).scroll(function() {
            var top_of_element = $("#smx-add-to-cart").offset().top;
            var bottom_of_element = $("#smx-add-to-cart").offset().top + $("#smx-add-to-cart").outerHeight();
            var bottom_of_screen = $(window).scrollTop() + $(window).innerHeight();
            var top_of_screen = $(window).scrollTop();

            if ((bottom_of_screen > top_of_element) && (top_of_screen < bottom_of_element)){
                $('#floating-add-to-cart').removeClass('show');
            } else {
                $('#floating-add-to-cart').addClass('show');
            }
        });

    }

})
(jQuery);
